import CustomTable from '../../../../components/table/CustomTable';
import HistoryApp from '../Functionality/HistoryApp';
import {CustomSelect} from "../../../../components/CustomSelect";
import React from "react";
import {CustomDatePicker} from "../../../../components/CustomDatePicker";
import CustomSearch from "../../../../components/SearchSimples/CustomSearch";
import CustomUserChip from "../../../../components/CustomUserChip";
import {InfoChip} from "../../../../components/buttons/IconButtons";
import {POSITION_MODEL} from "../../../../Helpers/PositionModel";

/**
 * @Author      Susana García Rodríguez
 * @JobTitle    Frontend Developer
 * @Email       sgarcia@ibl.mx
 */

const History = ({ item, setItem, handleChange, option, setBodyForExport, modified, setModified, emptyFields, setEmptyFields }) => {
    const {
        t,
        searchId,
        tableId,
        thead,
        tbody,
        pagination,
        cafeteriaOptions,
        searchText,
        setSearchText,
        handleSearch,
        onReset,
        yesterday
    } = HistoryApp({
        item,
        setItem,
        setBodyForExport,
        option,
        modified,
        setModified,
        setEmptyFields
    });
    return (
        <>
            <div className={"row"}>
                <div className='col-sm-12 col-md-3 px-0 px-md-2'>
                    <CustomSelect
                        id={'slt_h_cafeteria_id'}
                        name={'cafeteriaId'}
                        value={item.cafeteriaId}
                        keyName='id'
                        onChange={handleChange}
                        list={cafeteriaOptions}
                        trans={'diner'}
                        label={'lbl_dsh_cafeteria_id'}
                        required={false}
                    />
                </div>
                <div className='col-sm-12 col-md-3 px-0 px-md-2'>
                    <CustomDatePicker
                        id={'dp_h_date_filter'}
                        name={'date'}
                        disabled={false}
                        trans={'cafeteria_serving_date'}
                        value={item.date}
                        required={true}
                        maxDate={yesterday}
                        openTo={'day'}
                        onChange={(e) => {
                            handleChange({ target: { value: e, name: 'date' } });
                        }}
                        emptyFields={emptyFields}
                    />
                </div>
                <div className={'col-sm-12 col-md-6 px-0 px-md-2'}>
                    <CustomSearch id={searchId}
                                  label={"search_by_name_email_or_phone"}
                                  value={searchText}
                                  setValue={setSearchText}
                                  onChange={(e) => setSearchText(e.target.value)}
                                  searchFunction={handleSearch}
                                  onReset={onReset}
                    />
                </div>
            </div>
            { tbody?.data?.length > 0 &&
                <div className='w-100'>
                    <CustomUserChip
                        className='mt-0 chip-secondary-150-100 justify-content-start d-flex w-100'
                        name={t("information_not_updated_in_real_time")}
                        Icon={InfoChip}
                        showAvatar={true}
                        classNameIcon={'icon-color-secondary-700'}
                        variant='large'
                        iconPosition={POSITION_MODEL.LEFT}
                    />
                </div>
            }

            <CustomTable
                tableId={tableId}
                searchId={searchId}
                checkbox={false}
                columnActions={false}
                thead={thead}
                tbody={tbody}
                textNotInformation={item?.date ? 'no_records_for_this_day': 'please_select_a_date'}
                searchElement={searchText}
            />
             {pagination()}
        </>
    );
};

export default History;
